import { companyPeopleHeroSection } from './companyPeopleHeroSection.js';
import type { LandingContent } from '../../shared/content/landingContent.js';
import type { LandingEditorRenderOptions } from '../editor/landingEditorRender.js';
import type { LandingHomeSectionKey } from '../../shared/editor/landingEditorTypes.js';
import { audienceHeroSection } from './audienceHeroSection.js';
import { benefitsSection } from './benefitsSection.js';
import { consultationSection } from './consultationSection.js';
import { companyObjectionsSection } from './companyObjectionsSection.js';
import { companyMatchingSection } from './companyMatchingSection.js';
import { companyPlatformHeroSection } from './companyPlatformHeroSection.js';
import { contactSection } from './contactSection.js';
import { costSection } from './costSection.js';
import { faqSection } from './faqSection.js';
import { globusPartnerSection } from './globusPartnerSection.js';
import { globusCampaignHeroSection } from './globusCampaignHeroSection.js';
import { heroFanSection } from './heroFanSection.js';
import { heroSection } from './heroSection.js';
import { industryOverviewSection } from './industryOverviewSection.js';
import { infoSection } from './infoSection.js';
import { introSection } from './introSection.js';
import { knowledgeSection } from './knowledgeSection.js';
import { laborShortageSection } from './laborShortageSection.js';
import { partnersSection } from './partnersSection.js';
import { processSection } from './processSection.js';
import { qualitySection } from './qualitySection.js';
import { reasonsSection } from './reasonsSection.js';
import { recognitionSection } from './recognitionSection.js';
import { requirementsSection } from './requirementsSection.js';
import { storySection } from './storySection.js';
import { teamSection } from './teamSection.js';
import { valuesSection } from './valuesSection.js';

export const renderLandingHomeSection = (
  section: LandingHomeSectionKey,
  content: LandingContent,
  editor: LandingEditorRenderOptions,
) => {
  switch (section) {
    case 'hero':
      return heroSection(content, editor);
    case 'heroApplicant':
    case 'heroCompany':
      return content[section] ? audienceHeroSection(section, content, editor) : null;
    case 'heroFanApplicant':
    case 'heroFanCompany':
      return content[section] ? heroFanSection(section, content, editor) : null;
    case 'companyPeopleHero':
      return content.companyPeopleHero ? companyPeopleHeroSection(content, editor) : null;
    case 'companyPlatformHero':
      return content.companyPlatformHero ? companyPlatformHeroSection(content, editor) : null;
    case 'companyObjections':
      return companyObjectionsSection(content, editor);
    case 'companyMatching':
      return companyMatchingSection(content, editor);
    case 'globusCampaignApplicant':
    case 'globusCampaignCompany':
      return content[section] ? globusCampaignHeroSection(section, content, editor) : null;
    case 'intro':
      return introSection(content, editor);
    case 'industryOverview':
      return content.industryOverview ? industryOverviewSection(content, editor) : null;
    case 'laborShortage':
      return content.laborShortage ? laborShortageSection(content, editor) : null;
    case 'partners':
      return content.partners ? partnersSection(content, editor) : null;
    case 'globusPartner':
      return content.globusPartner ? globusPartnerSection(content, editor) : null;
    case 'reasons':
      return reasonsSection(content, editor);
    case 'benefits':
      return benefitsSection(content, editor);
    case 'costs':
      return costSection(content, editor);
    case 'recognition':
      return recognitionSection(content, editor);
    case 'requirements':
      return content.requirements ? requirementsSection(content, editor) : null;
    case 'faqApplicant':
    case 'faqCompany':
      return content[section] ? faqSection(section, content, editor) : null;
    case 'quality':
      return content.quality ? qualitySection(content, editor) : null;
    case 'knowledge':
      return content.knowledge ? knowledgeSection(content, editor) : null;
    case 'values':
      return content.values ? valuesSection(content, editor) : null;
    case 'consultationApplicant':
    case 'consultationCompany':
      return content[section] ? consultationSection(section, content, editor) : null;
    case 'process':
      return processSection(content, editor);
    case 'team':
      return teamSection(content, editor);
    case 'story':
      return storySection(content, editor);
    case 'info':
      return infoSection(content, editor);
    case 'contact':
      return contactSection(content, editor);
  }
};
